// Utilidades para el manejo de periodos mensuales (YYYY-MM) usados en
// evaluaciones colaborador→empresa dentro de Beeznz Work.

const MONTH_NAMES_ES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
]

/** Periodo actual en formato YYYY-MM. */
export function currentPeriod(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
}

/** Convierte un periodo "YYYY-MM" a una etiqueta legible, ej. "Agosto 2026". */
export function formatPeriodLabel(period: string): string {
  const [y, m] = period.split('-').map(Number)
  if (!y || !m || m < 1 || m > 12) return period
  return `${MONTH_NAMES_ES[m - 1]} ${y}`
}

/** Retorna la lista de periodos "YYYY-MM" entre startPeriod y endPeriod (ambos incluidos). */
export function monthsBetween(startPeriod: string, endPeriod: string): string[] {
  if (!startPeriod || !endPeriod) return []
  const [sy, sm] = startPeriod.split('-').map(Number)
  const [ey, em] = endPeriod.split('-').map(Number)
  if (!sy || !sm || !ey || !em) return []

  const months: string[] = []
  let y = sy
  let m = sm
  let guard = 0
  // Tope de seguridad para evitar loops infinitos ante datos inconsistentes
  while ((y < ey || (y === ey && m <= em)) && guard < 240) {
    months.push(`${y}-${String(m).padStart(2, '0')}`)
    m += 1
    if (m > 12) {
      m = 1
      y += 1
    }
    guard += 1
  }
  return months
}

/**
 * Calcula los periodos (YYYY-MM) pendientes de evaluación para un vínculo,
 * acotados entre el mes de inicio de la vinculación y el mes actual (o el
 * mes de finalización si el vínculo ya fue finalizado), excluyendo los
 * periodos que ya cuentan con una evaluación registrada.
 */
export function getPendingPeriods(params: {
  startRef?: string
  endRef?: string
  isFinalized: boolean
  evaluatedPeriods: Set<string>
}): string[] {
  const { startRef, endRef, isFinalized, evaluatedPeriods } = params
  const startPeriod = (startRef || '').slice(0, 7)
  if (!startPeriod) return []
  const capPeriod = isFinalized ? (endRef || '').slice(0, 7) || currentPeriod() : currentPeriod()
  const all = monthsBetween(startPeriod, capPeriod)
  return all.filter((p) => !evaluatedPeriods.has(p))
}
